import { Children, PureComponent } from 'react';

import get from 'lodash/get';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';

const CHILD_LINE_HEIGHT = 20;

export default class PinToBottom extends PureComponent {
  static propTypes = {
    children: PropTypes.object,
    data: ImmutablePropTypes.list.isRequired,
  };

  componentDidMount() {
    const node = get(this.wrapper, ['children', 0]);
    node.scrollTop = node.scrollHeight;
  }

  componentDidUpdate(prevProps) {
    const node = get(this.wrapper, ['children', 0]);
    const { clientHeight, scrollHeight, scrollTop } = node;
    const { data } = this.props;
    const addedItems = data.filter((item) => !prevProps.data.includes(item));
    const pinToBottom =
      clientHeight + scrollTop + addedItems.size * CHILD_LINE_HEIGHT >=
      scrollHeight;
    if (pinToBottom) {
      node.scrollTop = scrollHeight;
    }
  }

  render() {
    return (
      <div
        ref={(node) => {
          this.wrapper = node;
        }}
      >
        {Children.only(this.props.children)}
      </div>
    );
  }
}
